// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Job Creation Form Styling */
.job-creation-container {
  max-width: 1100px; 
  width: 90%; 
  margin: 40px auto 50px auto;  
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  min-height: 400px; 
}


.job-creation-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; 
}

.job-creation-content {
  flex: 1; 
}

/* Center align the title properly */
.form-title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: #ffffff;
  background: #1F4E72;
  padding: 10px;
  border-radius: 5px;
}

/* Ensure form fields are styled properly */
.job-form .ant-form-item-label {
  font-weight: 600;
}

/* Reduce input and select box width */
.job-form .ant-input,
.job-form .ant-select-selector,
.job-form .ant-input-textarea {
  border-radius: 5px;
}

/* Add spacing below inputs */
.ant-form-item {
  margin-bottom: 12px;
}

/* Center the buttons */
.ant-btn {
  width: 120px; /* Fixed button width */
}

/* Ensure primary button color */
.ant-btn-primary {
  background-color: #1F4E72 !important;
  border-color: #1F4E72 !important;
}

.ant-btn-primary:hover,
.ant-btn-primary:focus {
  background-color: #163A56 !important; /* Darker shade on hover */
  border-color: #163A56 !important;
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/components/JobCreationForm/JobCreationForm.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,OAAO;AACT;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;;;EAGE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,YAAY,EAAE,uBAAuB;AACvC;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC,EAAE,0BAA0B;EAChE,gCAAgC;AAClC","sourcesContent":["/* Job Creation Form Styling */\n.job-creation-container {\n  max-width: 1100px; \n  width: 90%; \n  margin: 40px auto 50px auto;  \n  padding: 20px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  min-height: 400px; \n}\n\n\n.job-creation-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; \n}\n\n.job-creation-content {\n  flex: 1; \n}\n\n/* Center align the title properly */\n.form-title {\n  text-align: center;\n  font-size: 22px;\n  font-weight: bold;\n  color: #ffffff;\n  background: #1F4E72;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n/* Ensure form fields are styled properly */\n.job-form .ant-form-item-label {\n  font-weight: 600;\n}\n\n/* Reduce input and select box width */\n.job-form .ant-input,\n.job-form .ant-select-selector,\n.job-form .ant-input-textarea {\n  border-radius: 5px;\n}\n\n/* Add spacing below inputs */\n.ant-form-item {\n  margin-bottom: 12px;\n}\n\n/* Center the buttons */\n.ant-btn {\n  width: 120px; /* Fixed button width */\n}\n\n/* Ensure primary button color */\n.ant-btn-primary {\n  background-color: #1F4E72 !important;\n  border-color: #1F4E72 !important;\n}\n\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  background-color: #163A56 !important; /* Darker shade on hover */\n  border-color: #163A56 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
